import { Reveal } from "../Reveal";
import { Chapter } from "../Chapter";
import { PhotoSlot } from "../PhotoSlot";

const STORY = [
  "I have two older children with my former partner in London. I now live in Portugal with my wife and our three younger children.",
  "Our family spans two countries, two homes, new partners, step-parents and half-siblings.",
  "My former partner and I were fortunate to separate without it becoming a legal battle. Today we get on better than we ever did. I’m friends with her boyfriend, and my wife and former partner have built a friendship of their own.",
  "None of that happened because we got everything right.",
  "I’ve learned a lot about resentment, accountability, empathy and focusing on what I can actually control.",
  "I’ve been through separation myself — trying to keep working, parenting and making sensible decisions while life around me felt anything but settled. Looking back, I know how valuable it would have been to have someone outside the situation who understood some of it and could simply help me work through what was immediately in front of me.",
  "Over the years, I’ve found myself having versions of that conversation with friends and people around me going through their own separations. Walk It Through grew naturally out of those conversations.",
];

export const WhyLuke = () => (
  <section id="why-luke" className="bg-paper2" data-testid="why-luke-section">
    <div className="mx-auto max-w-6xl px-5 md:px-8 py-24 md:py-36">
      <Chapter
        n={5}
        kicker="Why Luke"
        title="I’ve lived through this. I also know what good can look like afterwards."
      />
      <div className="grid gap-12 md:grid-cols-12 md:gap-10">
        <div className="md:col-span-4">
          <Reveal>
            <PhotoSlot
              src="/images/luke-portrait.jpg"
              alt="Luke sitting on a stone wall above the Portuguese coast, smiling"
              ratio="aspect-[3/4]"
              position="object-center"
              testid="luke-photo"
            />
            <p className="mt-4 flex items-baseline gap-3">
              <span className="font-serif text-2xl text-ink">Luke</span>
              <span className="text-sm text-ink/50">Portugal ↔ London</span>
            </p>
          </Reveal>
        </div>
        <div className="md:col-span-8 space-y-6 text-base md:text-lg leading-relaxed text-ink/75">
          {STORY.map((p, i) => (
            <Reveal key={i} delay={i * 0.05}>
              <p className={i === 3 ? "font-serif text-xl md:text-2xl text-ink" : ""}>{p}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
